import { PageHero } from "../components/PageHero";
import { Reveal } from "../lib/motion";
import { CASE_STUDIES, CLIENTS } from "../lib/data";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CaseStudies() {
  return (
    <>
      <PageHero
        testid="cases-hero"
        overline="Our Clients & Impact"
        title="Trusted by global organizations. Delivering measurable impact."
        subtitle="We partner with forward-thinking, mid-market organizations across sectors to solve complex challenges, drive performance and create lasting value."
      />

      <section className="bg-background py-24">
        <div className="container-x space-y-6">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.slug}>
              <Link
                to={`/case-studies/${c.slug}`}
                data-testid={`case-${c.slug}`}
                className="group grid gap-8 overflow-hidden rounded-2xl border border-border bg-background transition-all duration-300 hover:-translate-y-1 hover:border-accent/50 hover:shadow-[0_18px_50px_rgba(18,60,82,0.1)] md:grid-cols-12"
              >
                <div className={`relative min-h-[280px] overflow-hidden md:col-span-5 ${i % 2 ? "md:order-2" : ""}`}>
                  <img src={c.hero} alt={c.client} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-navy/20" />
                </div>
                <div className="md:col-span-7 md:p-12 p-8">
                  <p className="font-mono text-[11px] uppercase tracking-widest text-accent">{c.industry}</p>
                  <h2 className="mt-3 text-2xl font-semibold tracking-tight">{c.title}</h2>
                  <p className="mt-2 text-sm text-muted-foreground">{c.client}</p>
                  <p className="mt-5 leading-relaxed text-muted-foreground">{c.excerpt}</p>
                  <div className="mt-8 grid grid-cols-3 gap-4 border-t border-border pt-6">
                    {c.metrics.map((m) => (
                      <div key={m.v}>
                        <p className="font-display text-2xl font-semibold text-gradient">{m.k}</p>
                        <p className="mt-1 text-xs text-muted-foreground">{m.v}</p>
                      </div>
                    ))}
                  </div>
                  <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-accent">
                    Read the full story <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-border bg-secondary/40 py-24">
        <div className="container-x">
          <Reveal className="mb-12 max-w-2xl">
            <p className="overline text-accent">Client Roster</p>
            <h2 className="mt-4 text-balance text-3xl font-semibold tracking-tighter sm:text-4xl">
              Partnering with focused, high-growth enterprises.
            </h2>
          </Reveal>
          <div className="grid gap-px overflow-hidden rounded-2xl border border-border bg-border md:grid-cols-2 lg:grid-cols-3">
            {CLIENTS.map((c) => (
              <div key={c.name} className="bg-background p-8">
                <h3 className="font-display text-lg font-semibold tracking-tight">{c.name}</h3>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-widest text-accent">{c.location}</p>
                <p className="mt-3 text-sm text-muted-foreground">{c.industry} · {c.size}</p>
                <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{c.result}</p>
              </div>
            ))}
          </div>
          <Reveal className="mt-12">
            <Link to="/contact" className="inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-accent dark:bg-white dark:text-navy dark:hover:bg-accent dark:hover:text-white">
              Become our next success story <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
